const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches
const hoverCapable = () => window.matchMedia('(hover: hover)').matches

export class HomepageV2MachineCard extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return

    this.abortController = new AbortController()
    this.media = this.querySelector('video-media')
    this.video = this.media?.querySelector?.('video') || this.querySelector('video')
    this.bindVideoGuard(this.video)
    this.playbackRequested = false

    this.addEventListener('pointerenter', () => this.play(), {
      signal: this.abortController.signal,
    })
    this.addEventListener(
      'pointerleave',
      (event) => {
        if (!this.contains(event.relatedTarget)) this.reset()
      },
      { signal: this.abortController.signal },
    )
    this.addEventListener('focusin', () => this.play(), {
      signal: this.abortController.signal,
    })
    this.addEventListener(
      'focusout',
      (event) => {
        if (!this.contains(event.relatedTarget)) this.reset()
      },
      { signal: this.abortController.signal },
    )
  }

  bindVideoGuard(video) {
    if (this.boundVideo === video) return

    if (this.boundVideo && this.handleVideoPlay) {
      this.boundVideo.pause()
      this.boundVideo.removeEventListener('play', this.handleVideoPlay)
    }

    this.handleVideoPlay ||= () => {
      if (!this.playbackRequested || !this.abortController) {
        this.pauseNow()
        queueMicrotask(() => {
          if (!this.playbackRequested || !this.abortController) this.pauseNow()
        })
      }
    }
    this.boundVideo = video
    this.boundVideo?.addEventListener('play', this.handleVideoPlay)
  }

  disconnectedCallback() {
    this.reset()
    this.abortController?.abort()
    this.abortController = null
  }

  play() {
    if (!this.media || reducedMotion() || !hoverCapable()) return
    this.hydrateVideoSources(this.video)
    this.playbackRequested = true
    this.playbackGeneration = (this.playbackGeneration || 0) + 1
    const promise = this.media.play()
    promise?.catch?.(() => {})
  }

  hydrateVideoSources(video) {
    if (!video) return

    let sourceChanged = false
    video.querySelectorAll('source[data-src]').forEach((source) => {
      const src = source.dataset.src
      if (!src || source.getAttribute('src') === src) return

      source.setAttribute('src', src)
      sourceChanged = true
    })

    if (sourceChanged) video.load()
  }

  reset() {
    this.playbackRequested = false
    const generation = (this.playbackGeneration || 0) + 1
    this.playbackGeneration = generation
    this.pauseNow()
    queueMicrotask(() => {
      if (generation === this.playbackGeneration && !this.playbackRequested) this.pauseNow()
    })
  }

  pauseNow() {
    if (!this.media) return
    this.media.pause()
    if (!this.video) return
    this.video.pause()
    this.media.removeAttribute('playing')
    try {
      this.video.currentTime = 0
    } catch {
      // Some browsers disallow seeking until metadata is ready.
    }
  }
}

if (!customElements.get('homepage-v2-machine-card')) {
  customElements.define('homepage-v2-machine-card', HomepageV2MachineCard)
}
